<template>
  <!-- Area Lance Inicio -->
  <div class="area-lance">
    <div class="lances-incremento">
      <div class="lances-content">
        <span class="lances-label">Lances:</span>
        <span class="quantidade-laces">{{ historicoLances }}</span>
      </div>
      <div class="incremento-content">
        <span class="incremento-label">Incremento:</span>
        <span class="valor-incremento">
          {{ $root.formatarPreco(lote.raw_incremento) }}
        </span>
      </div>
    </div>
    <div v-if="lote.vl_lanceminimo > 0 && leilao.bn_exibeavaliacao"
         class="avaliacao-content">
      <div class="avaliacao-label">
        <i class="icon-info"></i>
        <span>Avaliação</span>
      </div>
      <span class="avaliacao-valor">{{ $root.formatarPreco(lote.vl_lanceminimo) }}</span>
    </div>
    <div v-if="lote.vl_lanceinicial > 0"
         class="lance-minimo-content">
      <div class="lance-minimo-label">
        <i class="icon-dollar"></i>
        <span>
          Lance {{ showLanceMinAtual ? 'mín. (Atual)' : 'mínimo' }}
        </span>
      </div>
      <span class="lance-minimo-valor">{{ this.$root.formatarPreco(lote.vl_lanceinicial) }}</span>
    </div>
    <div v-if="showLanceMinAtual && leilao.bn_exibedesconto"
         class="lance-minimo-content">
      <div class="lance-minimo-label">
        <i class="icon-dollar"></i>
        <span>Lance mínimo (Próx. data) </span>
      </div>
      <span class="lance-minimo-valor">{{
          this.$root.formatarPreco(lote.vistoria[0].vl_lanceinicialsegundoleilao)
        }}</span>
    </div>
    <div class="tw-flex-col tw-py-2 tw-w-full bg-white tw-rounded-md">
      <div class="lance-atual-content">
        <div class="lance-atual-label">
          <i class="icon-dollar"></i>
          <span>Último lance</span>
        </div>
        <span class="lance-atual-valor">
          {{ $root.formatarPreco(lanceAtual.vl_lance) }}
        </span>
      </div>
      <div v-if="mainDomain !== 'meirelesleiloes'" class="lance-usuario-content">
        <div class="lance-usuario-label">
          <i class="icon-user-circle"></i>
          <span>Usuário</span>
        </div>
        <span v-if="lanceAtual.nm_apelido !== null" class="lance-usuario-nome">
          {{ "@" + lanceAtual.nm_apelido }}
        </span>
      </div>
      <div v-else-if="mainDomain === 'meirelesleiloes'" class="lance-usuario-content">
        <span v-if="lanceAtual.nm_apelido !== null" class="nome-usuario-lance">
          {{ "@" + lanceAtual.nm_apelido }}
        </span>
      </div>
    </div>

    <div class="tw-flex-col">
      <!-- Forma de Pagamento -->
      <div
        :class="['tw-flex-col tw-justify-between tw-items-center tw-mt-2 tw-mb-3 tw-font-new tw-rounded', classParcelamento]">
        <div class="tw-p-2 tw-flex tw-items-center tw-justify-between">
          <span class="tw-font-new tw-font-semibold tw-text-white tw-text-[15px]">Forma de pagamento</span>
          <div
            v-if="leilao.bn_aceitelanceparcelado || lote.bn_aceitelanceparceladolote"
            class="tw-flex tw-items-center"
          >
            <select
              class="tw-py-2 md:tw-px-4 tw-mr-1 tw-bg-jrGray-200 tw-font-new tw-text-[15px] tw-font-bold tw-text-white tw-rounded-md focus-visible:tw-border-none"
              v-model="qtdParcelas"
              id="limite_parcelas"
              @focus="calcParcelamento(lote)"
            >
              <option
                class="tw-text-white tw-flex tw-items-center tw-text-[15px]"
                v-for="(parcela, idx) in parcelamento"
                :key="idx"
                :value="parcela"
              >
                {{ parcela === 1 ? "À vista" : parcela + " x" }}
              </option>
            </select>
          </div>
          <div v-else class="tw-text-white tw-rounded-md tw-font-bold">
            <span class="tw-px-2">
              {{
                lanceAtual.nu_parcelas && lanceAtual.nu_parcelas > 1 ? `Parcelado em ${lanceAtual.nu_parcelas}x` : "À vista"
              }}
            </span>
          </div>
        </div>
        <div v-if="qtdParcelas > 1" class="parcelas-container">
          <label for="percentualEntrada" class="percentual-label">Entrada</label>
          <div class="percentual-input-container">
            <button type="button" @click="decrementarPercentual" class="percentual-btn"
                    :disabled="lote.nu_intervaloparcelaslote !== 5">
              -
            </button>
            <input type="number" id="percentualEntrada" v-model.number="lote.nu_limitepercentuallote"
                   :min="lote.nu_limitepercentuallote" step="0.5" class="percentual-input" readonly/>
            <button type="button" @click="incrementarPercentual" class="percentual-btn"
                    :disabled="lote.nu_intervaloparcelaslote !== 5">
              +
            </button>
            <span class="percentual-sufix">%</span>
          </div>
        </div>
        <div
          v-if="qtdParcelas > 1"
          class="tw-text-[12px] tw-font-semibold tw-flex-col tw-letter-[1px] tw-pb-2 tw-px-2 tw-flex tw-items-end tw-text-white tw-w-full"
        >
          <span v-if="lote.nu_limitepercentuallote > 0">( entrada de {{ lote.nu_limitepercentuallote }}% )</span>
          <div v-if="lote.nm_indicecorrecao">
            <span class="">Índice de correção: {{ lote.nm_indicecorrecao }}</span>
          </div>
        </div>
      </div>
      <!-- Enviar Lance -->
      <button
        v-if="statusLote.statuslote === 'Vendido' || !liberacao_lote"
        class="tw-w-full tw-bg-jrGray-200 tw-rounded-md tw-flex tw-justify-between tw-items-center tw-text-lg tw-px-3 tw-py-2 tw-cursor-not-allowed hover:tw-opacity-75"
        id="enviar_lance"
        disabled="disabled"
      >
        <span>{{ !liberacao_lote ? 'Enviar lance' : 'Lance inicial' }}</span>
        <span class="tw-font-semibold tw-font-new tw-flex tw-items-center">{{
            $root.formatarPreco(lanceAtual.vl_lance_sugerido)
          }}<i
            class="icon-justice-hammer tw-text-md tw-ml-4"></i></span>
      </button>
      <button
        v-else
        :title="!usuario.id ? 'Você precisa estar logado' : 'Enviar'"
        class="tw-w-full tw-rounded-md tw-flex tw-justify-between tw-items-center tw-text-[15px] tw-font-semibold tw-text-white tw-px-3 tw-py-2 hover:tw-shadow-md"
        :class="!liberado || !liberacao_lote ? 'tw-bg-jrGreen-new tw-flex tw-items-center tw-cursor-not-allowed' : 'tw-bg-jrGreen-new'"
        id="enviar_lance"
        @click="usuario.id && liberacao_lote ? enviarLance( $root.formatarPreco(lanceAtual.vl_lance_sugerido), 'lance' ) : alerta()"
      >
        <span>{{ liberacao_lote ? 'Enviar lance' : 'Lance inicial' }}</span>
        <span class="tw-font-semibold tw-font-new tw-flex tw-items-center">
          <span>{{ $root.formatarPreco(lanceAtual.vl_lance_sugerido) }}</span>
          <i class="icon-justice-hammer tw-text-md tw-ml-4"></i>
        </span>
      </button>

      <!-- Igualar Lance a vista -->
      <div
        v-if="lanceAtual.nu_parcelas > 1 && (lote.nu_intervaloparcelaslote === 1 || lote.nu_intervaloparcelaslote === 2 || lote.nu_intervaloparcelaslote === 4 || lote.nu_intervaloparcelaslote === 5)">
        <button
          id="enviar_lance_manual"
          @click="igualarLanceAtual()"
          :disabled="!liberado || !liberacao_lote"
          class="tw-mt-3 tw-w-full tw-rounded-md tw-flex tw-justify-center tw-text-[15px] tw-items-center tw-font-bold tw-text-md tw-px-3 tw-py-2 tw-text-white hover:tw-shadow-md"
          :class="!liberado || !liberacao_lote ? 'tw-bg-jrGreen-new tw-cursor-not-allowed' : 'tw-bg-jrGreen-new'"
        >
          <span>Igualar com lance à vista</span>
          <i class="icon-justice-hammer tw-text-md tw-ml-2"></i>
        </button>
      </div>

    </div>

    <div v-if="leilao.statusleilao_id !== 1 && leilao.statusleilao_id !== 5 && leilao.statusleilao_id !== 8">

      <!-- Lance Manual -->
      <div v-if="leilao.statusleilao_id !== 13" class="tw-flex tw-justify-between tw-gap-2 tw-font-new">
        <div class="tw-w-full tw-px-2 tw-py-2 tw-rounded-md tw-bg-jrGray-50">
          <label class="tw-flex tw-justify-between tw-items-center">
            <span class="lance-manual">
              <i class="icon-dollar tw-mr-2"></i>
              Lance manual:
            </span>
            <input
              value=""
              v-money="money"
              id="enviar_lance_manual_val"
              @keyup="qtdParcelas = 1; calcParcelamento(lote)"
              class="tw-w-1/2 focus:tw-outline-none tw-border-none tw-bg-white tw-py-1 tw-px-2 tw-rounded-md tw-font-bold tw-text-right">
          </label>
        </div>
        <button
          v-if="statusLote.statuslote === 'Vendido' || !liberacao_lote"
          id="enviar_lance_manual"
          disabled="disabled"
          class="tw-w-12 tw-px-2 tw-border tw-rounded-md tw-bg-jrGreen-new tw-cursor-not-allowed tw-text-white tw-justify-center tw-flex tw-items-center hover:tw-opacity-75">
          Ok
        </button>
        <button
          v-else-if="mainDomain !== 'meirelesleiloes'"
          id="enviar_lance_manual"
          @click="enviarLance(true, 'lance')"
          :disabled="!liberado || !liberacao_lote"
          :class="!liberado || !liberacao_lote ? 'tw-bg-jrGreen-new tw-cursor-not-allowed' : 'tw-cursor-pointer tw-bg-jrGreen-new'"
          class="tw-w-12 tw-px-2 tw-border tw-rounded-md tw-text-white tw-justify-center tw-flex tw-items-center hover:tw-opacity-75"
        >
          Ok
        </button>
        <button
          v-else-if="mainDomain === 'meirelesleiloes'"
          id="enviar_lance_manual"
          @click="enviarLance(true, 'lance')"
          :disabled="!liberado || !liberacao_lote"
          :class="!liberado || !liberacao_lote ? 'tw-bg-jrBlue-new tw-cursor-not-allowed' : 'tw-cursor-pointer tw-bg-jrBlue-new'"
          class="tw-w-12 tw-px-2 tw-border tw-rounded-md tw-text-white tw-justify-center tw-flex tw-items-center hover:tw-opacity-75"
        >
          Ok
        </button>
      </div>

      <!-- Lance Venda Direta -->
      <div v-else class="tw-flex tw-justify-between tw-gap-2 tw-font-new tw-mt-8">
        <div class="tw-w-full tw-px-2 tw-py-2 tw-bg-jrGray-100 tw-rounded-md">
          <label class="tw-flex tw-justify-between tw-items-center">
            <span class="tw-w-1/2 tw-font-medium tw-leading-5">
              {{
                paramsite_proposta.bn ? 'Lance Condicional' : 'Venda Direta'
              }}:
            </span>
            <input
              value=""
              v-money="money"
              id="enviar_lance_manual_val"
              @keyup="qtdParcelas = 1; calcParcelamento(lote)"
              class="tw-w-1/2 focus:tw-outline-none tw-border-none tw-bg-white tw-py-1 tw-px-2 tw-rounded-md tw-font-bold tw-text-right">
          </label>
        </div>
        <button
          v-if="statusLote.statuslote === 'Vendido' || !liberacao_lote"
          id="enviar_lance_manual"
          disabled="disabled"
          class="tw-w-12 tw-px-2 tw-border tw-rounded-md tw-bg-jrGreen-new tw-cursor-not-allowed tw-text-white tw-justify-center tw-flex tw-items-center hover:tw-opacity-75">
          Ok
        </button>
        <button
          v-else
          id="enviar_lance_manual"
          @click="enviarLance(true, 'venda_direta')"
          :disabled="!liberado || !liberacao_lote"
          :class="!liberado || !liberacao_lote ? 'tw-bg-jrGreen-new tw-cursor-not-allowed' : 'tw-cursor-pointer tw-bg-jrGreen-new'"
          class="tw-w-12 tw-px-2 tw-border tw-rounded-md tw-text-white tw-justify-center tw-flex tw-items-center hover:tw-opacity-75"
        >
          Ok
        </button>
      </div>

      <!-- Lance automático -->
      <div v-if="leilao.statusleilao_id !== 13" class="tw-flex tw-justify-between tw-gap-2 tw-font-new tw-mt-2">
        <div class="tw-w-full tw-px-2 tw-py-2 tw-bg-jrGray-50 tw-rounded-md">
          <label class="tw-flex tw-justify-between tw-items-center">
            <div class="tw-w-1/2 tw-font-semibold tw-text-[15px] tw-leading-5 tw-flex tw-items-center">
              <i
                title="O que é"
                class="tw-text-sm tw-cursor-pointer icon-info"
                @click="limiteLanceMsg"
              >
              </i>
              <span class="tw-ml-2 lance-automatico">Lance Automático:</span>
            </div>
            <input
              v-money="money"
              id="enviar_limite_lance_val"
              class="tw-w-1/2 focus:tw-outline-none tw-border-none tw-bg-white tw-py-1 tw-px-2 tw-rounded-md tw-font-bold tw-text-right"
              value=""
            />
          </label>
        </div>
        <button
          v-if="statusLote.statuslote === 'Vendido' || !liberacao_lote"
          disabled="disabled"
          class="tw-w-12 tw-px-2 tw-border tw-rounded-md tw-bg-jrGreen-new tw-cursor-not-allowed tw-text-white tw-justify-center tw-flex tw-items-center hover:tw-opacity-75">
          Ok
        </button>
        <button
          v-else-if="mainDomain !== 'meirelesleiloes'"
          id="enviar_limite_lance"
          :class="!liberado || !liberacao_lote ? 'tw-bg-jrGreen-new tw-cursor-not-allowed' : 'tw-cursor-pointer tw-bg-jrGreen-new'"
          class="tw-w-12 tw-px-2 tw-border tw-rounded-md tw-text-white tw-justify-center tw-flex tw-items-center hover:tw-opacity-75"
          @click="enviaLimiteLance"
          :disabled="!liberado || !liberacao_lote"
        >
          Ok
        </button>
        <button
          v-else-if="mainDomain === 'meirelesleiloes'"
          id="enviar_limite_lance"
          :class="!liberado || !liberacao_lote ? 'tw-bg-jrBlue-new tw-cursor-not-allowed' : 'tw-cursor-pointer tw-bg-jrBlue-new'"
          class="tw-w-12 tw-px-2 tw-border tw-rounded-md tw-text-white tw-justify-center tw-flex tw-items-center hover:tw-opacity-75"
          @click="enviaLimiteLance"
          :disabled="!liberado || !liberacao_lote"
        >
          Ok
        </button>
      </div>
      <div
        class="tw-flex tw-justify-between tw-gap-2 tw-font-new"
        v-else
        v-show="statusLote.statuslote_id !== 4 &&
              statusLote.statuslote_id !== 5 &&
              statusLote.statuslote_id !== 7 &&
              statusLote.statuslote_id !== 9 &&
              !leilao.bn_aceitelanceparcelado"
      >
        <div class="tw-w-full tw-px-2 tw-py-2 tw-bg-white tw-bg-opacity-40 tw-rounded-md">
          <label class="tw-flex tw-justify-between tw-items-center">
            <span class="tw-w-1/2 tw-font-medium tw-leading-5">Venda direta:</span>
            <input
              v-money="money"
              id="enviar_lance_proposta"
              class="tw-w-1/2 focus:tw-outline-none tw-border-none tw-bg-white tw-py-1 tw-px-2 tw-rounded-md tw-font-bold tw-text-right"
              value=""
            />
          </label>
        </div>
        <button
          v-if="statusLote.statuslote === 'Vendido'"
          id="enviar_lance_manual"
          disabled="disabled"
          class="tw-w-12 tw-px-2 tw-border tw-rounded-md tw-bg-jrGreen-new tw-cursor-not-allowed tw-text-white tw-justify-center tw-flex tw-items-center hover:tw-opacity-75">
          Ok
        </button>
        <button
          v-else
          id="enviar_lance_manual"
          class="tw-w-12 tw-px-2 tw-border tw-rounded-md tw-text-white tw-justify-center tw-flex tw-items-center hover:tw-opacity-75"
          @click="enviaPropostaVendaDireta()"
          :disabled="!liberado || !liberacao_lote"
          :class="!liberado || !liberacao_lote ? 'tw-bg-jrGreen-new tw-cursor-not-allowed' : 'tw-cursor-pointer tw-bg-jrGreen-new'">
          Ok
        </button>
      </div>

      <div
        v-if="leilao.statusleilao_id !== 13 && !leilao.bn_aceitelanceparcelado"
        class="tw-flex tw-items-center tw-justify-center tw-mt-2"
      >

      </div>
      <div v-else>
        <div
          v-show="
                statusLote.statuslote_id !== 4 &&
                statusLote.statuslote_id !== 5 &&
                statusLote.statuslote_id !== 7 &&
                statusLote.statuslote_id !== 9 &&
                !leilao.bn_aceitelanceparcelado"
          class="tw-flex tw-items-center tw-justify-center"
        >
          <span>Enviar Proposta?</span>
          <i title="O que é" class="tw-ml-1 tw-cursor-pointer icon-info" @click="propostaMsg"></i>
        </div>
      </div>

      <!-- Limite cadastrado -->
      <div v-show="lote.vl_lanceautomatico" class="tw-flex tw-justify-center tw-items-center tw-mt-2">
        <div v-show="lote.vl_lanceautomatico"
             class="tw-px-3 tw-bg-jrRed-50 tw-rounded-md tw-text-white tw-text-sm tw-py-1 tw-mb-3">
          Limite cadastrado: {{ lote.vl_lanceautomatico }} {{ lote.nu_parcelas }}
          <i @click="removeLimiteLance" class="icon-close tw-text-xs tw-ml-2"></i>
        </div>
      </div>

      <Countdown :statuslote_id="statusLote.statuslote" :deadline="dt_fechamento_lote"></Countdown>

      <!-- Limite cadastrado -->
      <div
        v-for="(vistoria, id) in lote.vistoria"
        :key="id"
        v-if="vistoria.usuariovistorialotexstatusliberacaoextra !== undefined"
        @click.prevent="liberacaoExtraMsg(vistoria.usuariovistorialotexstatusliberacaoextra)"
        class="tw-flex tw-justify-center tw-items-center tw-mt-2">
        <div
          class="tw-px-3 tw-bg-jrGray-300 tw-cursor-pointer tw-animate-pulse tw-rounded-md tw-text-white tw-text-sm tw-py-1">
          Requer habilitação especial
          <i class="icon-lock tw-text-xs tw-ml-2"></i>
        </div>
      </div>

    </div>
    <div v-else class="tw-text-jrRed-50 tw-px-3 tw-py-1 tw-rounded tw-bg-white tw-text-center tw-font-semibold">
            <span class="tw-flex tw-justify-center tw-items-center tw-gap-2"><i class="icon-warning tw-text-xs"></i>Leilão com lances somente presenciais.<i
              class="icon-warning tw-text-xs"></i></span>
    </div>
  </div>
  <!-- Area Lance Fim -->

</template>

<script>
import LeilaoSocial from "@/components/shared/social/LeilaoSocial.vue";
import Countdown from "@/components/shared/Countdown.vue";
import {isValidBid} from '@/assets/js/utils.js';


export default {
  components: {
    Countdown,
    LeilaoSocial,
  },
  props: [
    "lote",
    "leilao",
    "liberado",
    "isfavorito",
    "usuario",
    "historico",
    "lanceAtual",
    "statusLote",
    "automatico",
    "dt_fechamento_lote",
    "liberacao_lote",
    "paramsite_proposta",
    "time",
    "isRunningOut",
    "historicoLances"
  ],
  data() {
    return {
      intervalLance: null,
      errors: [],
      qtdParcelas: 1,
      limite: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      showShare: false,
      parcelamento: 1,
      nu_limitepercentualloteInicial: 0,
      tipoParcelamento: false,
      saladisputa: false,
    };
  },
  watch: {
    'leilao'(novo, ant) {
      this.leilao = novo
    },
    'lote'(novo, ant) {
      if (novo) {
        this.qtdParcelas = 1;
        this.verificarTitoDeParcelamento();
        this.calcularDiferencaPercentual();
      }
    }
  },
  computed: {
    lanceMinimo() {
      if (this.leilao.leilao_id_primeiroleilao === null && this.leilao.datas < 1) {
        return this.lote['vistoria'][0].vl_lanceinicial;
      } else {
        if (!this.lote['vistoria'][0].vl_lanceinicialsegundoleilao || isNaN(this.lote['vistoria'][0].vl_lanceinicialsegundoleilao)) {
          return this.lote['vistoria'][0].vl_lanceinicial;
        } else {
          return this.lote['vistoria'][0].vl_lanceinicialsegundoleilao;
        }
      }
    },
    comissaoArrematanteLote() {
      return parseInt(this.lote.vistoria[0].nu_comissaoarrematantelote);
    },
    mainDomain() {
      const domainParts = window.location.hostname.split('.');
      return domainParts.length > 2 ? domainParts[1] : domainParts[0];
    },
    classParcelamento() {
      if (this.mainDomain === 'meirelesleiloes') {
        return 'tw-bg-jrBlue-new';
      } else {
        return 'tw-bg-jrGray-200';
      }
    },
    showLanceMinAtual() {
      if (this.lote['vistoria']) {
        return isValidBid(this.lote['vistoria'][0].vl_lanceinicialsegundoleilao, this.lote['vistoria'][0].vl_lanceinicial);
      }

      return false;
    }
  },
  methods: {
    calcularDiferencaPercentual() {
      this.nu_limitepercentualloteInicial = this.lote.nu_limitepercentuallote;

      if (!this.lote.vistoria || !this.lote.vistoria[0]) return;

      const val1 = parseFloat(this.lote.vistoria[0].vl_lanceinicial);
      const val2 = parseFloat(this.lote.vistoria[0].vl_lanceinicialsegundoleilao);

      if (isNaN(val1) || isNaN(val2)) return;

      const diferenca = val1 - val2;
      const percentual = (diferenca / val1) * 100;

      this.diferencaPercentual = percentual.toFixed(2);
    },

    incrementarPercentual() {
      if (this.lote.nu_limitepercentuallote < 100) {
        this.lote.nu_limitepercentuallote += 1;
      }
    },

    decrementarPercentual() {
      if (this.lote.nu_limitepercentuallote > this.nu_limitepercentualloteInicial) {
        this.lote.nu_limitepercentuallote -= 1;
      }
    },

    async verificarTitoDeParcelamento() {
      if (!this.saladisputa) return;

      try {
        this.tipoParcelamento = await this.saladisputa.tipoParcelamento(
          this.lote.leilao_id,
          this.lote.lote_id
        );
      } catch (error) {
        console.error('Erro ao verificar tipo de parcelamento:', error);
      }
    },

    getLink() {
      return window.location.href;
    },

    alerta() {
      let mensagemBox = this.$parent.$refs.mensagem.$el
      window.scrollTo(0, mensagemBox)

      this.$toast.open({
        message: 'Você precisa estar logado pra dar lances!',
        type: 'error',
        duration: 5000,
        position: 'top-right',
      });
    },
    addFavorito() {
      this.$parent.$emit("addFavorito", this.Isfavorito);
    },

    enviarLance(val, tipo) {

      var valor = 0;
      var preferencia = window.localStorage.getItem('a5cc51388b67c5c132389a6ffc950dbf');

      if (val == true) {
        val = document.querySelector("#enviar_lance_manual_val").value;
        val = "R$ " + val;
      }
      valor = val.replace(/\./g, "").replace("R$ ", "").replace(",", ".");

      var isLance = true;
      if (tipo != "undefined") {
        if (tipo == "venda_direta") {
          isLance = false;
        }
      }

      const self = this;
      const hostName = location.protocol + "//" + window.HOSTNAME;
      const leilaoIdTratado = self.$route.params.id;
      const loteIdTratado = self.$route.params.idlote;

      let limiteParcelas = "";
      let parcelas = 1;
      if (
        this.leilao.bn_aceitelanceparcelado ||
        this.lote.bn_aceitelanceparceladolote
      ) {
        parcelas = document.querySelector("#limite_parcelas").value;
        limiteParcelas = `&nu_parcelas=${
          document.querySelector("#limite_parcelas").value
        }`;
        //lance trt
        if (this.lote.nu_intervaloparcelaslote == 4) {
          if (valor == this.lanceAtual.vl_lance && parcelas >= this.lanceAtual.nu_parcela) {
            this.$toast.open({
              message: 'Lance não foi registrado. O Lance enviado deve ser maior que o lance Atual!11',
              type: 'error',
              duration: 5000,
              position: 'top-right',
            });
            return false;
          }
        } else if (this.lote.nu_intervaloparcelaslote == 5) {
          var percentuallote = self.lote.nu_limitepercentuallote;
          if (valor < this.lanceAtual.vl_lance || parcelas < this.lanceAtual.nu_parcela || percentuallote < this.lanceAtual.vl_percentualentrada) {
            this.$toast.open({
              message: 'Lance não foi registrado. O Lance enviado deve ser maior que o lance Atual!5_11',
              type: 'error',
              duration: 5000,
              position: 'top-right',
            })
          }
        } else {
          if (valor == this.lanceAtual.vl_lance && !preferencia.includes(self.usuario.id)) {
            this.$toast.open({
              message: 'Lance não foi registrado. O Lance enviado deve ser maior que o lance Atual!22',
              type: 'error',
              duration: 5000,
              position: 'top-right',
            });
            return false;
          }
        }
      }

      let db = this.firebase_db;
      let usuarioIdLogado = null;
      let usuarioIdUltimoLance = null;
      let limitPercentualLote = Math.round(self.lote.nu_limitepercentuallote);

      db.ref(`/lance/${leilaoIdTratado}/${loteIdTratado}`)
        .orderByChild("id")
        .limitToLast(1)
        .once("value")
        .then(function (data) {
          usuarioIdLogado = self.usuario.id;

          if (data.val()) {
            usuarioIdUltimoLance = Object.values(data.val())[0].nm_usuario_id;
          }

          if (usuarioIdLogado === usuarioIdUltimoLance) {

            let textoModal = `<p style="color: red;"><strong>VOCÊ JÁ TEM O MAIOR LANCE DESTE LOTE, DESEJA COBRIR O PRÓPRIO LANCE?</strong></p>
                              <p>${self.lote.nm_titulo}</p>
                              <p style="background-color: #f5f5f5; padding: 10px; border-radius: 5px; margin: 10px 0;">
                                <strong style="color: #314666;">Condições de pagamento:</strong><br>
                                ${parcelas > 1
              ? `<span>Entrada: <strong>${limitPercentualLote}%</strong></span><br>
                                     <span>Parcelas: <strong>${parcelas}x</strong></span>`
              : `<span>Pagamento: <strong>à vista</strong></span>`
            }
                              </p>
                              <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;"> ${val}</strong></p>`;

            if (self.statusLote && self.statusLote.statuslote === 'Dou-lhe Duas') {
              self.$toast.open({
                message: 'Tempo de envio de lance esgotado.',
                type: 'error',
                duration: 4000,
                position: 'top-right',
              });
              return false;
            }

            self.$modal.show("dialog", {
              title: `<strong style="font-size:20px;color: #512925;">Lote ${self.lote.nu}</strong>`,
              text: textoModal,
              buttons: [
                {
                  title: "NÃO",
                  handler: () => {
                    self.loading = false;
                    self.$modal.hide("dialog");
                  },
                },
                {
                  title: "SIM",
                  default: true, // HABILITAR BOTÃO ENTER
                  handler: () => {
                    self.$modal.hide("dialog");
                    modalEnviaLance(
                      self,
                      hostName,
                      leilaoIdTratado,
                      loteIdTratado,
                      val,
                      valor,
                      limiteParcelas,
                      isLance
                    );
                  },
                },
              ],
            });
          } else {
            if (self.statusLote && self.statusLote.statuslote === 'Dou-lhe Duas') {
              self.$toast.open({
                message: 'Tempo de envio de lance esgotado.',
                type: 'error',
                duration: 4000,
                position: 'top-right',
              });
              return false;
            }

            modalEnviaLance(
              self,
              hostName,
              leilaoIdTratado,
              loteIdTratado,
              val,
              valor,
              limiteParcelas,
              isLance
            );
          }
        });
    },

    limiteLanceMsg() {
      this.$modal.show("dialog", {
        title: `Lance automático`,
        text: `<p>O lance automático possibilita que o usuário agende previamente o valor limite dos seus lances.</p>
                    <p>Dessa forma o usuário que não pode acompanhar o leilão simultaneamente tem a garantia de que seus lances serão enviados automaticamente até o valor estipulado pelo mesmo.</p>
                    <p>O sistema validará o lance a ser enviado de acordo com o valor de incremento do momento, sendo assim, caso o lance automático cadastrado seja inferior ao valor do último lance + valor de incremento do momento, seu lance não será efetivado.</p>
                    <p><strong>Obs.</strong> O valor do lance automático é confidencial.</p>
                    `,
        buttons: [
          {
            title: "Fechar",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
        ],
      });
    },

    propostaMsg() {
      this.$modal.show("dialog", {
        title: `Envio de Proposta`,
        text: `<p>Ao enviar uma proposta, o leiloeiro irá receber uma notificação para avaliar o valor enviado e entrará em contato com o comprador.
                    <p><strong>Obs.</strong> O valor da proposta é confidencial.</p>
                    `,
        buttons: [
          {
            title: "Fechar",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
        ],
      });
    },

    liberacaoExtraMsg(descricao) {
      this.$parent.modalHabilitacao(descricao);
    },

    enviaLimiteLance() {
      const val = document.querySelector("#enviar_limite_lance_val").value;
      const valor = val.replace(/\./g, "").replace("R$ ", "").replace(",", ".");

      const valorEnvioManual = document.querySelector("#enviar_lance_manual_val").value.replace(/\./g, "").replace("R$ ", "").replace(",", ".");

      const incremento = parseFloat(this.lote.raw_incremento);

      const valorMinimoPermitido = parseFloat(valorEnvioManual) + incremento;

      if (parseFloat(valor) < valorMinimoPermitido) {
        document.querySelector("#enviar_limite_lance_val").value = this.$root.formatarPreco(valorMinimoPermitido)
        return this.$toast.open({
          message: `Limite de lance deve ser maior ou igual ao lance atual mais o incremento: ${this.$root.formatarPreco(valorMinimoPermitido)}`,
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }

      const self = this;

      const hostName = location.protocol + "//" + window.HOSTNAME;
      const leilaoIdTratado = self.$route.params.id;
      const loteIdTratado = self.$route.params.idlote;

      let limiteParcelas = "";
      let parcelas = 1;
      if (
        self.leilao.bn_aceitelanceparcelado ||
        self.lote.bn_aceitelanceparceladolote
      ) {
        parcelas = document.querySelector("#limite_parcelas").value;
        limiteParcelas = `&nu_parcelas=${
          document.querySelector("#limite_parcelas").value
        }`;
      }
      var nmDescricao = "<p>Confirma o limite de lance ";
      if (parcelas > 1) nmDescricao += ` Parcelado em ${parcelas}x ? </p>`;
      else nmDescricao += ` à vista ? </p>`;

      let textoModal =
        `  <p>${self.lote.nm_titulo}</p> ` +
        nmDescricao +
        `  <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;">R$ ${val}</strong></p>`;

      if (self.statusLote && self.statusLote.statuslote === 'Dou-lhe Duas') {
        self.$toast.open({
          message: 'Tempo de envio de lance esgotado.',
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
        return false;
      }

      self.$modal.show("dialog", {
        title: `<strong style="font-size:20px;">Lote ${self.lote.nu}</strong>`,
        text: textoModal,
        buttons: [
          {
            title: "Cancelar",
            handler: () => {
              self.$modal.hide("dialog");
            },
          },
          {
            title: "Enviar limite",
            default: true, // HABILITAR BOTÃO ENTER
            handler: () => {
              self.loading = true;

              fetch(`${hostName}/leilao/envialanceauto?leilao_id=${leilaoIdTratado}&lote_id=${loteIdTratado}&vl_lance=${valor}&force=0${limiteParcelas}&firebase=1`, {method: 'POST'})
                .then((res) => {
                  if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                  }
                  return res.json();
                })
                .then((res) => {
                  clearInterval(this.intervalLance);
                  if (res.erro == true) {
                    self.errors.push(res);
                    this.$toast.open({
                      message: self.$root.decodeHtml(res.msg_erro),
                      type: 'error',
                      duration: 4000,
                      position: 'top-right',
                    });
                    document.querySelector("#enviar_limite_lance_val").value =
                      "";
                    self.$modal.hide("dialog");
                  } else {
                    localStorage.setItem(
                      "valor_limite_lote" + self.$route.params.idlote,
                      val
                    );
                    this.intervalLance = this.verificaLanceAutomatico();
                  }
                  self.$parent.$emit("callDadosGerais");

                  document.querySelector("#enviar_limite_lance_val").value = "";
                  self.$modal.hide("dialog");
                })
                .catch((e) => {
                  document.querySelector("#enviar_limite_lance_val").value = "";
                  self.errors.push(e);
                  self.$modal.hide("dialog");
                });
            },
          },
        ],
      });
    },

    removeLimiteLance() {
      const val = this.lote.vl_lanceautomatico;
      if (!val) {
        return;
      }
      const valor = val.replace(/\./g, "").replace("R$ ", "").replace(",", ".");
      const self = this;

      const hostName = location.protocol + "//" + window.HOSTNAME;
      const leilaoIdTratado = self.$route.params.id;
      const loteIdTratado = self.$route.params.idlote;

      self.$modal.show("dialog", {
        title: `<strong style="font-size:20px;">Lote ${self.lote.nu}</strong>`,
        text: ` <p>${self.lote.nm_titulo}</p>
                            <p>Remover o limite de lance? </p>
                            <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;">${val}</strong> </p>`,
        buttons: [
          {
            title: "Cancelar",
            handler: () => {
              self.$modal.hide("dialog");
            },
          },
          {
            title: "Remover Limite",
            default: true, // HABILITAR BOTÃO ENTER
            handler: () => {
              self.loading = true;

              fetch(
                `${hostName}/leilao/removelanceauto/leilao_id/${leilaoIdTratado}/lote_nu/${self.lote.nu}?leilao_id=${leilaoIdTratado}&lote_id=${loteIdTratado}&vl_lance=${valor}&force=0&firebase=1`
              )
                .then((res) => {
                  if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                  }
                  return res.json();
                })
                .then((res) => {
                  if (res.erro == true) {
                    self.errors.push(res);
                    this.$toast.open({
                      message: self.$root.decodeHtml(res.msg_erro),
                      type: 'error',
                      duration: 4000,
                      position: 'top-right',
                    });
                    self.$modal.hide("dialog");
                  }

                  self.$parent.$emit("callDadosGerais", self);
                  // FECHA MODAL E PARA O LOADING
                  self.$modal.hide("dialog");
                })
                .catch((e) => {
                  self.errors.push(e);
                  self.$modal.hide("dialog");
                });
            },
          },
        ],
      });
    },

    enviaPropostaVendaDireta() {
      const val = document.querySelector("#enviar_lance_proposta").value;
      const valor = val.replace(/\./g, "").replace("R$ ", "").replace(",", ".");
      const self = this;

      const hostName = location.protocol + "//" + window.HOSTNAME;
      const leilaoIdTratado = self.$route.params.id;
      const loteIdTratado = self.$route.params.idlote;

      const vl_percentual = 90;
      const percentual_proposta =
        (self.lote.vl_lanceinicial * vl_percentual) / 100;

      if (valor < percentual_proposta) {
        this.$toast.open({
          message: 'Sua Proposta deve ser no mínimo ' + vl_percentual + '% do valor inicial: ' + self.$root.formatarPreco(self.lote.vl_lanceinicial),
          type: 'error',
          duration: 5000,
          position: 'top-right',
        });
        return false;
      }

      self.$modal.show("dialog", {
        title: `<strong style="font-size:20px;">Lote ${self.lote.nu}</strong>`,
        text: ` <p>${self.lote.nm_titulo}</p>
                            <p>Confirma a proposta de lance? </p>
                            <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;">R$ ${val}</strong> </p>`,
        buttons: [
          {
            title: "Cancelar",
            handler: () => {
              self.$modal.hide("dialog");
            },
          },
          {
            title: "ENVIAR PROPOSTA",
            default: true, // HABILITAR BOTÃO ENTER
            handler: () => {
              self.loading = true;

              fetch(`${hostName}/leilao/enviaproposta?leilao_id=${leilaoIdTratado}&lote_id=${loteIdTratado}&vl_lance=${valor}`, {method: 'POST'})
                .then((res) => {
                  if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                  }
                  return res.json();
                })
                .then((res) => {
                  if (res.data.erro == true) {
                    self.errors.push(res);
                    this.$toast.open({
                      message: self.$root.decodeHtml(res.data.msg_erro),
                      type: 'error',
                      duration: 4000,
                      position: 'top-right',
                    });
                    document.querySelector("#enviar_lance_proposta").value = "";
                    self.$modal.hide("dialog");
                  }

                  self.$parent.$emit("callDadosGerais");

                  document.querySelector("#enviar_lance_proposta").value = "";
                  self.$modal.hide("dialog");
                  this.$toast.open({
                    message: "Sua proposta foi enviada com sucesso. Em breve um de nossos atendentes entrará em contato para dizer se sua proposta foi aceita. Qualquer dúvida por favor entrar em contato via telefone. Obrigado.",
                    type: 'error',
                    duration: 10000,
                    position: 'top-right',
                  });
                })
                .catch((e) => {
                  document.querySelector("#enviar_lance_proposta").value = "";
                  self.errors.push(e);
                  self.$modal.hide("dialog");
                });
            },
          },
        ],
      });
    },

    verificaLanceAutomatico() {
      setInterval(() => {
        console.log("verificaLanceAutomatico");
        var valor_limite_lote = localStorage.getItem(
          "valor_limite_lote" + this.$route.params.idlote
        );
        if (
          this.usuario_id_logado !== this.usuario_id_ultimolance &&
          this.valor_limite_lote >= this.lanceAtual.vl_lance_sugerido
        ) {
          this.enviarLanceAutomatico(this.lanceAtual.vl_lance_sugerido);
        }
      }, 10000);
    },

    enviarLanceAutomatico(valorLance) {
      var url = `${
        location.protocol + "//" + window.HOSTNAME
      }/leilao/envialance/?ajax=1&leilao_id=${this.$route.params.id}&lote_id=${
        this.$route.params.idlote
      }&vl_lance=${this.lanceAtual.vl_lance_sugerido}&force=0${
        this.limiteParcelas ? this.limiteParcelas : 0
      }&firebase=1&automatico=1`;
      fetch(url, {method: 'POST'})
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then((res) => {
          document.querySelector("#enviar_lance_manual_val").value = valorLance;

          if (res.data.dados_lote) {
            document.querySelector("#enviar_lance_manual_val").value =
              valorLance;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    igualarLanceAtual() {
      let val = this.$root.formatarPreco(this.lanceAtual.vl_lance);
      let valorFormatado = val
        .replace(/\./g, "")
        .replace("R$ ", "")
        .replace(",", ".");

      this.$modal.hide("dialog");
      this.$modal.show("dialog", {
        title: `<strong style="font-size:20px;color: #512925;">Lote ${this.lote.nu}</strong>`,
        text: `
          <p style="color: red;"><strong>VOCÊ DESEJA IGUALAR O VALOR ATUAL DE MANEIRA À VISTA?</strong></p>
          <p>${this.lote.nm_titulo}</p>
          <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;"> ${val}</strong> </p>
        `,
        buttons: [
          {
            title: "CANCELAR",
            handler: () => {
              this.loading = false;
              this.$modal.hide("dialog");
            },
          },
          {
            title: "ENVIAR",
            default: true, // HABILITAR BOTÃO ENTER
            handler: () => {
              this.loading = true;

              fetch(`${location.protocol + "//" + window.HOSTNAME}/leilao/envialance/?ajax=1&leilao_id=${this.$route.params.id}&lote_id=${this.$route.params.idlote}&vl_lance=${valorFormatado}&force=0${1}&firebase=1`, {method: 'POST'})
                .then((res) => {
                  if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                  }
                  return res.json();
                })
                .then((res) => {
                  if (res.erro == true) {
                    this.errors.push(res);
                    this.$toast.open({
                      message: (this.$root.decodeHtml(res.msg_erro)),
                      type: 'error',
                      duration: 4000,
                      position: 'top-right',
                    });
                    document.querySelector("#enviar_lance_manual_val").value =
                      this.lote.vl_lance_sugerido;
                  }
                  if (res.dados_lote) {

                    document.querySelector("#enviar_lance_manual_val").value =
                      res.dados_lote.vl_lance_sugerido;
                  }
                  // FECHA MODAL E PARA O LOADING
                  this.$modal.hide("dialog");
                })
                .catch((e) => {
                  this.$modal.hide("dialog");
                  this.errors.push(e);
                });
            },
          },
        ],
      });
    },

    calcParcelamento(lote) {
      var valor = document.querySelector("#enviar_lance_manual_val").value;
      this.parcelamento = lote.nu_limiteparcelaslote ? this.$root.refreshParcelamento(lote, valor) : 1;
    },

  },

  created() {
    //this.parcelamento = 2;
    this.saladisputa = new window.saladisputa(this);
    this.verificarTitoDeParcelamento();
  },
  destroyed() {
    clearInterval(this.intervalLance);
  },
};

function modalEnviaLance(
  self,
  hostName,
  leilaoIdTratado,
  loteIdTratado,
  val,
  valor,
  limiteParcelas,
  isLance,
  igualarlanceavista
) {
  let percentuallote = self.lote.nu_limitepercentuallote;
  var nmDescricao = "<p>Confirmar o envio de lance?";
  if (isLance == false) {
    nmDescricao = "<p>Confirmar a venda direta";
    if (self.paramsite_proposta.bn == true) {
      nmDescricao = "<p>Confirmar o lance condicional";
    }
  }
  let parcelas = 1;
  let limitPercentualLote = Math.round(self.lote.nu_limitepercentuallote);
  let comissaoArramatanteLote = Math.round(self.lote['vistoria'][0].nu_comissaoarrematantelote);

  if (
    self.leilao.bn_aceitelanceparcelado ||
    self.lote.bn_aceitelanceparceladolote
  ) {
    parcelas = document.querySelector("#limite_parcelas").value;
  }

  if (parcelas > 1 && !igualarlanceavista && limitPercentualLote > 0) {
    nmDescricao += `<p style="background-color: #f5f5f5; padding: 10px; border-radius: 5px; margin: 10px 0;">
                        <strong style="color: #314666;">Condições de Pagamento:</strong><br>
                        <span>Entrada: <strong>${limitPercentualLote}%</strong></span><br>
                        <span>Parcelas: <storng>${parcelas}x</storng></span>
                    </p>`;
  } else if (parcelas > 1 && !igualarlanceavista && limitPercentualLote <= 0) {
    nmDescricao += `<p style="background-color: #f5f5f5; padding: 10px; border-radius: 5px; margin: 10px 0;">
                        <strong style="color: #314666;">Condições de Pagamento:</strong><br>
                        <span>Entrada: <strong>${comissaoArramatanteLote}%</strong></span><br>
                        <span>Parcelas: <storng>${parcelas}x</storng></span>
                    </p>`;
  } else {
    nmDescricao += `<p style="background-color: #f5f5f5; padding: 10px; border-radius: 5px; margin: 10px 0;">
                        <strong style="color: #314666;">Condições de Pagamento:</strong><br>
                        <span>Pagemento: <strong>à vista</strong></span><br>
                    </p>`;
  }

  let textoModal =
    ` <p>${self.lote.nm_titulo}</p> ` +
    nmDescricao +
    ` <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;">${val}</strong> </p>`;

  self.$modal.show("dialog", {
    title: `<strong style="font-size:20px;">Lote ${self.lote.nu}</strong>`,
    text: textoModal,
    buttons: [
      {
        title: "Cancelar",
        handler: () => {
          self.$modal.hide("dialog");
        },
      },
      {
        title: "Enviar",
        default: true, // HABILITAR BOTÃO ENTER
        handler: () => {
          self.loading = true;

          fetch(`${hostName}/leilao/envialance/?ajax=1&leilao_id=${leilaoIdTratado}&lote_id=${loteIdTratado}&vl_lance=${valor}&force=0${limiteParcelas}&firebase=1&percentuallote=${percentuallote}`, {method: 'POST'})
            .then((res) => {
              if (!res.ok) {
                throw new Error(`HTTP error! Status: ${res.status}`);
              }
              return res.json();
            })
            .then((res) => {
              if (res.erro === true) {
                self.errors.push(res);

                self.$toast.open({
                  message: self.$root.decodeHtml(res.msg_erro),
                  type: 'error',
                  duration: 4000,
                  position: 'top-right',
                });

                document.querySelector("#enviar_lance_manual_val").value =
                  self.lote.vl_lance_sugerido;

              } else if (res.dados_lote) {
                document.querySelector("#enviar_lance_manual_val").value =
                  res.dados_lote.vl_lance_sugerido;
              }

              self.$modal.hide("dialog");
            })
            .catch((e) => {
              self.$modal.hide("dialog");
              self.errors.push(e);
              self.$toast.open({
                message: "Erro ao enviar lance: " + e.message,
                type: 'error',
                duration: 4000,
                position: 'top-right',
              });
            });
        },
      },
    ],
  });
}

</script>

<style>
/* area de lance */
.header-area-lance h1 {
  font-weight: 600 !important;
  padding-right: 30px;
  /*text-align: justify;*/
}

.area-lance {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 50%;
}

.lances-incremento,
.avaliacao-content,
.avaliacao-label,
.lance-minimo-content,
.lance-minimo-label,
.lance-atual-content,
.lance-atual-label,
.lance-usuario-content,
.lance-usuario-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lances-content,
.incremento-content,
.avaliacao-content,
.lance-minimo-content {
  font-size: 15px;
  color: #7A7A7A;
}

.lance-atual-content,
.lance-usuario-content,
.lance-manual,
.lance-automatico {
  color: #1C2D47;
  font-size: 15px;
}

.lances-label,
.avaliacao-label,
.lance-atual-label,
.lance-minimo-label,
.lance-minimo-label span,
.avaliacao-label span,
.lance-atual-label span,
.lance-usuario-label,
.lance-usuario-label span {
  margin-left: 0.5rem;
}

.quantidade-laces,
.valor-incremento,
.avaliacao-valor,
.lance-minimo-valor,
.lance-atual-valor,
.lance-usuario-nome {
  font-weight: 700;
}

.lance-atual-valor,
.lance-usuario-nome {
  margin-right: 0.5rem;
}

.lance-usuario-nome {
  text-decoration: underline;
}

.lance-manual, .lance-automatico {
  display: flex;
  align-items: center;
  font-weight: bold;
}

.nome-usuario-lance {
  width: 100%;
  display: flex;
  justify-content: end;
  margin-right: .5rem;
  color: #106f8c;
  font-size: 14px;
  font-weight: 500;
}

@media (max-width: 1024px) {
  .lances-content,
  .incremento-content,
  .avaliacao-content,
  .lance-minimo-content,
  .lance-atual-content,
  .lance-usuario-content,
  .lance-manual,
  .lance-automatico {
    font-size: 13px;
  }
}

h1.title-header-area {
  font-size: 35px !important;
  padding: 3px 0;
  font-weight: 300 !important;
  color: #62615a !important;
  position: relative;
}

.hasPortions {
  margin-bottom: 0 !important;
}

.portion {
  font-size: 18px;
  width: 100%;
  margin-left: 2px !important;
  color: red;
}

.lance-atual-header {
  font-size: 13px;
  color: #2c672b;
  position: absolute;
  top: 8px;
  right: 0;
}

.btn-lance {
  padding: 12px;
  font-size: 20px !important;
  background: #67302b;
  color: #fff;
  border: 1px solid rgb(81, 81, 81);
  width: 100%;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.3s;
}

.label-span-help {
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #d6d6d6;
  display: block;
  text-align: center;
  font-size: 12px;
  position: relative;
  padding: 7px 29px 11px 33px;
  text-align: left;
}

.label-span-help:before {
  content: "";
  width: 0;
  height: 0;
  border: 7px solid #000;
  position: absolute;
  top: -0.4px;
  left: -17px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid transparent;
  border-right: 12px solid #d6d6d6;
}

.btn-lance:hover {
  background: #438855;
  border: 1px solid #438855;
}

#enviar_lance {
  margin-bottom: 14px !important;
}

.input-manual {
  padding: 12px;
  font-size: 20px !important;
  border: 1px solid #ccc;
  width: 100%;
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-lance-input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.container-input-lance {
  padding: 0 !important;
}

.container-btn-lance {
  padding: 0 !important;
}

.lance-input-group {
  margin: 15px 0 0;
}

.col-padding-lance {
  padding: 14px 0;
}

button {
  margin: 0 !important;
}

button:disabled,
button:disabled .text {
  pointer-events: all !important;
}

button:disabled {
  opacity: 1 !important;
}

.countdown {
  padding: 0 14px !important;
  margin: -1px -5px -11px -9px;
}

.add-favorito-novo {
  text-align: right;
  font-size: 20px;
  cursor: pointer;
  border-radius: 30px;
  padding: 6px 4px 4px 6px;
  background: #fff;
  box-shadow: 1px 1px 1px #ccc;
}

.box-heart {
  max-width: 30px;
}

.box-circle {
  border-radius: 30px;
  padding: 6px 4px 4px 5px;
  background: #fff;
  box-shadow: 1px 1px 1px #ccc;
}

.inline-flex {
  display: inline-flex;
}

.share-buttons {
  visibility: hidden;
  opacity: 0;
  transition: all 1s ease;
  left: 0;
  margin-left: -100px;
}

.share-buttons-on {
  visibility: visible;
  opacity: 1;
  left: 100%;
  margin-left: 4px;
}

.pointer {
  cursor: pointer;
}

.box {
  margin-left: 7px;
  max-width: 30px;
  margin-bottom: 10px;
}

.habilitacao_salaDisputa {
  display: flex;
  text-align: center;
  justify-content: center;
  font-size: 18px;
  background: #d6d6d6;
  color: #000;
  height: 50px;
  border-radius: 5px;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  transition: .3s;
}

.habilitacao_salaDisputa:hover {
  background: #b3b3b3;
}

.habilitacao img {
  margin-right: 5px;
}

.vl-lanceinicial {
  margin: 5px 0 5px 0;
  font-weight: 600;
  font-size: 1.1em;
}

.vl-avaliacao {
  font-size: 1.5em;
}

.product-info__lote-info {
  font-size: 1.3em;
}

.indice-correcao {
  font-size: 14px;
  font-weight: bold;
}

@media (max-width: 980px) {
  .label-span-help {
    margin-top: -12px;
    padding: 10px;
    text-align: center;
  }

  .label-span-help:before {
    display: none;
  }
}

@media (max-width: 768px) {
  .area-lance {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    gap: 0.75rem !important;
  }

  .lance-automatico,
  .lance-manual {
    font-size: 12px !important;
  }

  #enviar_limite_lance_val,
  #enviar_lance_manual_val {
    width: 45.3333% !important;
  }

  #enviar_lance span {
    font-size: 16px !important;
  }
}

@media (max-width: 435px) {
  #enviar_lance_manual_val, #enviar_limite_lance_val {
    font-size: 13px !important;
  }

  .lance-automatico, .lance-manual {
    font-size: 11px !important;
  }
}

@media (max-width: 600px) {
  .lt-lance {
    padding: 22px !important;
  }
}

.parcelas-container {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.percentual-label {
  width: 58px;
  text-align: right;
  margin: 0 5px;
  padding-top: 6px;
  color: #f9f9f9;
}

.percentual-input-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

.percentual-btn {
  height: 23px;
  width: 23px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  border: 0.5px solid #000;
  border-radius: 50%;
}

.percentual-btn:hover {
  background-color: #000;
  color: #fff;
}

.percentual-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.percentual-input {
  max-width: 45px;
  padding: 0 5px;
  text-align: left;
  border: 0.5px solid #000;
  border-radius: 10px;
}

.percentual-sufix {
  margin-left: 8px;
  font-size: 16px;
  color: #f9f9f9;
}

/*.product-info {*/
/*max-width: 100%;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/shared/AreaLance.vue